import React, { useEffect, useState } from 'react';
import AdminDashboard from 'layouts/AdminDashboard';
import { Box, Breadcrumbs } from '@mui/material';
import { getQuestion } from './QuestionService';
import { useParams } from 'react-router-dom';
import Container from 'components/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import QuestionAnswerList from './QuestionAnswerList';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const QuestionDetail = (): JSX.Element => {
  const [questionContent, setQuestionContent] = useState('');
  const [status, setStatus] = useState('');
  const { questionid } = useParams<{ questionid: string }>();

  useEffect(() => {
    if (questionid) {
      const questionIdAsNumber: number = parseInt(questionid);
      console.log('questionid exists: ', questionid);
      getQuestion(questionIdAsNumber)
        .then((response) => {
          console.log(response.data);
          setQuestionContent(response.data.questionContent);
          setStatus(response.data.status);
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }, [questionid]);

  return (
    <Container>
      <AdminDashboard>
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              System Content
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/system/dashboard/sections"
            >
              Questions
            </Link>
            <Typography color="text.primary">Question Detail</Typography>
          </Breadcrumbs>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom={4}
        >
          <Typography variant="h4">Question Detail</Typography>
        </Box>
        {/* {loading && <p>Loading...</p>} */}

        <Box>
          <form>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Question Content
                </Typography>
                <TextField
                  variant="outlined"
                  name={'name'}
                  fullWidth
                  value={questionContent} // Use the 'questionContent' state variable as the value
                  onChange={(event) => setQuestionContent(event.target.value)}
                  InputProps={{
                    readOnly: true, // Make the TextField read-only
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Status
                </Typography>
                <TextField
                  variant="outlined"
                  name={'status'}
                  fullWidth
                  value={status} // Use the 'status' state variable as the value
                  onChange={(event) => setStatus(event.target.value)}
                  InputProps={{
                    readOnly: true, // Make the TextField read-only
                  }}
                />
              </Grid>
              <Grid item container xs={12}>
                <Box
                  display="flex"
                  flexDirection={{ xs: 'column', sm: 'row' }}
                  alignItems={{ xs: 'stretched', sm: 'center' }}
                  justifyContent={'space-between'}
                  width={1}
                  marginBottom={4}
                ></Box>
              </Grid>
            </Grid>
          </form>
        </Box>

        <Box>
          <QuestionAnswerList />
        </Box>
      </AdminDashboard>
    </Container>
  );
};

export default QuestionDetail;
